class Estimated {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    let functions = this;

    let estimatedTime = [];
    let contactResult = [];

    const tmp_path = $('body').data('path');

    $.ajax({
      url: `${tmp_path}/lib/estimated.json`,
      type: 'GET',
      dataType: "json",
    }).done(function (data) {

      functions.summary(data, 0, data['item'].length, estimatedTime, contactResult);

    }).fail(function (data) {
      // error
      console.log('error');
    });
  }

  summary(data, index, length, estimatedTime, contactResult) {
    let progress = Math.floor(100 * index / length);
    let order;
    let fadeSpeed = 300;
    let functions = this;
    let result = data['item'][index];
    let text = this.text(result);
    let radio = this.radio(result);
    let btn = this.btn(result);

    this.imgRandom();

    if(index === 0) {
      $('.js-back').css({display: 'none'});
    } else {
      $('.js-back').css({display: 'inline-flex'});
    }
    
    $('.js-progress hr').animate({width: progress + '%'});
    $('.js-progress p').text(progress + '%');

    $('.js-content').empty();
    $('.js-content').append(text, radio, btn);

    $('.js-content').attr('data-step', index);

    $('.js-back').off();

    if(radio) {
      $('.js-btn-next').css({opacity: '0.3', pointerEvents: 'none'});

      $('.js-radio').change(function() {
        $('.js-btn-next').css({opacity: '1', pointerEvents: 'inherit'});
        $('.js-btn-next').data('time', $(this).data('time'));
        $('.js-btn-next').data('text', $(this).data('text'));
      });
    }

    $('.js-btn-next, .js-back').click(function() {

      if($(this).hasClass('js-btn-next')) {
        order = 1;
        contactResult.push($(".js-q_text").text() + " : " + $(this).data('text'))
        estimatedTime.push($(this).data('time'));
      } else {
        order = -1;
        contactResult.pop();
        estimatedTime.pop();
      }

      if(data['item'][index + order]) {
        $('.js-content, .js-img').animate({opacity: 0}, fadeSpeed);
      } else {
        $('.js-progress hr').animate({width: '100%'});
        $('.js-progress p').text('100%');
        $('.js-content, .js-img, .js-progress, .js-back').animate({opacity: 0}, fadeSpeed);
      }

      setTimeout(() => {
        $('.js-content').empty();
        functions.judge(data, index + order, length, estimatedTime, contactResult, functions, fadeSpeed);
        $('.js-content, .js-img').animate({opacity: 1}, fadeSpeed);
      }, fadeSpeed);
    })
  }

  judge(data, index, length, estimatedTime, contactResult, functions, fadeSpeed) {
    let result = data['item'][index];
    let result_before = data['item'][index - 1];
    let text,btn;
    if(result) {
      text = this.text(result);
      btn = this.btn(result);
    }

    let total = estimatedTime.reduce(function(sum, element){
      return Math.round(sum + element);
    }, 0);

    this.imgRandom();

    if(result_before && result_before['interruption'] && total == '0') {
      functions.result(data, estimatedTime, contactResult, fadeSpeed, functions);
    } else if(text && btn) {
      functions.summary(data, index, length, estimatedTime, contactResult);
    } else {
      functions.result(data, estimatedTime, contactResult, fadeSpeed, functions);
    }
  }

  result(data, estimatedTime, contactResult, fadeSpeed, functions) {
    let result = data.result;

    let resultText, contactResultJoin;
    
    let total = estimatedTime.reduce(function(sum, element){
      return Math.round(sum + element);
    }, 0);

    contactResultJoin = contactResult.join(',');

    result.forEach(function(el, index) {
      let startTime = result[index].startTime;
      let endTime = result[index].endTime;
      let text = result[index].text;

      if(total >= startTime && total <= endTime) {
        let result_time;
        if(total == 0) {
          result_time = '0時限';
        } else {
          result_time = (Number(total)) + "〜" + (Number(total) + 2) + "時限";
        }
        resultText = $(`
          <div style="opacity: 0;">
            <h3 class="result_ttl">あなたの講習目安時間はこちらです！</h3>
            <p class="result_time">${result_time}</p>
            <div class="result_text"><div>${text}</div></div>
            <a href="${$('body').data('home')}?send=講習時間目安 : ${result_time},${contactResultJoin}" class="c-btn-push result_btn js-btn-result">お申し込み／お問い合わせ</a>
          </div>
        `)
      }
    });

    $('.js-result').empty();
    $('.js-result').append(resultText);
    $('.js-result > *, .js-img').animate({opacity: 1}, fadeSpeed);
  }

  imgRandom() {
    let imgRandom = 0;
    while(true){
      imgRandom = Math.floor(Math.random() * 4) + 1;
      if($(".js-img").data('num') != imgRandom) {
        break;
      }
    }
    let imgsrc = $(".js-img").data('src').replace('$', imgRandom);

    $(".js-img").attr('data-num', imgRandom);
    $(".js-img").attr('src', imgsrc);
  }

  text(result) {
    if(result['text']) {
      return $(`
        <p class="q_text js-q_text">${result['text']}</p>
      `)
    }
  }

  radio(result) {
    let radio;
    if(result['radio']) {
      radio = $(`
        <ul class="radio_btn">
        </ul>
      `)
      let radio_el;
      result['radio'].forEach(el => {
        const radio_el = `
          <li class="${el['class']}">
            <label>
              <input type="radio" name="radio" class="radio_btn_item js-radio" data-time="${el['time']}" data-text="${el['text']}">
              <span>
                ${el['text']}
              </span>
            </label>
          </li>
        `;
        radio.append(radio_el);
      });
    }
    return radio;
  }

  btn(result) {
    let btn;
    if(result['btn']) {
      btn = $(`
        <div class="btn_wrap">
        </div>
      `)
      let btn_el;
      result['btn'].forEach(el => {
        const btn_el = `
          <button data-time="${el['time']}" data-text="${el['text']}" class="c-btn-push js-btn-next">${el['text']}</button>
        `;
        btn.append(btn_el);
      });
    }
    return btn;
  }
}